import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager';
import { Alert } from '../../../js/ComponentManager'
/* 개발담당:이재호
 * 화면기능:폴더이동, 추가
 * 세부설명:
*/

export class FolderEdit extends Component {
    static displayName = FolderEdit.name;

    constructor(props) {
        super(props);
        this.state = {
            NewFolder_Yn: "N",
            Folder_Name: "",
            FolderList: [],
            SelectModel: [],
            Edit_Code: "",
        };
        this.ref_FolderEdit = React.createRef();

        this.handleSave_Click = this.handleSave_Click.bind(this);
        this.handleCreate_Click = this.handleCreate_Click.bind(this);
        this.handle_Change = this.handle_Change.bind(this);
        this.handleMove_Click = this.handleMove_Click.bind(this);
    }
    //초기화
    componentDidMount() {
    }

    //폴더 리스트 조회
    async CallBokmkFolderList(edit_code, SelectModel) {
        try {
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post('api/MyPage/BookMark/GetMyBokmkFolderList', {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let FolderList = JSON.parse(Data.dataTable);
                this.setState({
                    FolderList: FolderList,
                    Edit_Code: edit_code
                });
                if (SelectModel.length > 0) {
                    this.setState({
                        SelectModel: SelectModel
                    });
                }
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallBokmkFolderList", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }

    handleCreate_Click() {
        this.setState({
            NewFolder_Yn: "Y"
        });
    }
    handle_Change(event, list, key) {
        let tagId = event.target.id;
        let value = event.target.value;
        if (tagId === 'Folder_Name') {
            this.setState({
                [tagId]: value,
            });
        }
        else {
            list[key] = value;
            this.setState({
                [tagId]: value,
            });
        }

        return false;
    }
    //검색 TextBox
    handleSearch_Blur(event) {
        const value = event.target.value;
        this.setState({ Update_Name: value });
        event.preventDefault();
    }
    async handleSave_Click() {
        try {
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post("api/MyPage/BookMark/RegisterBokmkFolder",
                {
                    folder_name: this.state.Folder_Name
                }, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.setState({
                    Title: Data.message,
                    NewFolder_Yn: "N",
                    Folder_Name: "",
                });
                this.CallBokmkFolderList(this.state.Edit_Code, '');
                this.props.CallBokmkFolderList();
            }
            else {
                this.setState({ Title: Data.message, Folder_Name: "" });
            }
        }
        catch (e) {
            console.log("handleSave_Click", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    async handleModify_Click(event, list, Crud) {
        try {
            const Folder_Name = list.folder_name;
            if (Folder_Name === "") {
                this.setState({ Title: "폴더명은 필수 입니다." });
            }
            else {
                Big3Common.Util.LoadingOn();
                const Model = { ...list, Crud: Crud };

                let Data = await Big3Common.Post("api/MyPage/BookMark/ModifyBokmkFolder",
                    Model
                    , true);
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    this.setState({
                        Title: Data.message,
                    });
                    this.CallBokmkFolderList(this.state.Edit_Code, '');
                    this.props.CallBokmkFolderList();
                }
                else {
                    this.setState({ Title: Data.message });
                }
            }
        }
        catch (e) {
            console.log("handleModify_Click", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        event.preventDefault();
    }
    async handleMove_Click(event, folder_no) {
        try {
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post("api/MyPage/BookMark/ModifyGoodsFolder", {
                SelectList: this.state.SelectModel,
                folder_no: folder_no,
            }, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.setState({ Title: Data.message });
                Big3Common.ModalAlert(bootstrap, "FolderEditAlert");
            }
            else {
                this.setState({ Title: Data.message });
            }
        }
        catch (e) {
            console.log("handleMove_Click", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        event.preventDefault();
    }

    Editrender() {
        const FolderList = this.state.FolderList;
        return (
            <>
                {
                    FolderList.map(list =>
                        <div className="box" key={list.folder_no}>
                            <div className="icon"></div>
                            <input
                                type="text"
                                id="Update_Name"
                                onChange={(e) => { this.handle_Change(e, list, "folder_name") }}
                                value={list.folder_name || ""}
                                maxLength="10"
                            />
                            <button className="move" onClick={(e) => {this.handleModify_Click(e, list, 'U') }}>수정</button>
                            <button className="f_delete" onClick={(e) => { this.handleModify_Click(e, list, 'D') }}>삭제</button>
                        </div>
                    )
                }
            </>     
        );
    }
    Moverender() {
        const FolderList = this.state.FolderList;
        return (
            <>
                <div className="box">
                    <div className="icon"></div>
                    <div className="title">전체보기</div>
                    <button className="move" onClick={(e) => { this.handleMove_Click(e, null) }}>이동</button>
                </div>
                {
                    FolderList.map(list =>
                        <div className="box" key={list.folder_no}>
                            <div className="icon"></div>
                            <div className="title">{list.folder_name}</div>
                            <button className="move" onClick={(e) => { this.handleMove_Click(e, list.folder_no) }}>이동</button>
                        </div>
                    )
                }
            </>
        );
    }

    render() {
        let Editrender = this.Editrender();
        let Moverender = this.Moverender();
        let Edit_Code = this.state.Edit_Code;
        let NewFolder_Yn = this.state.NewFolder_Yn
        let FolderList = this.state.FolderList;
        return (
            <div ref={this.ref_FolderEdit} className="modal fade" id={this.props.id} tabIndex="-1" data-bs-keyboard="false" data-bs-backdrop="static">
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content">
                        <div className="modal-header modal-header_v2">
                            <h4 className="modal-title h4" id="exampleModalFullscreenLabel">
                                {Edit_Code === 'E' ? "폴더편집" : "폴더선택" }
                            </h4>
                            <button className="folder_plus" onClick={this.handleCreate_Click} >+ 폴더추가</button>
                            <button className="folder_close" data-bs-dismiss="modal" onClick={() => {
                                if (this.props.CallBack) {
                                    this.props.CallBack();
                                }
                            }}>닫기</button>
                        </div>
                        <div className="folder_edit_box">
                            {NewFolder_Yn === 'Y' ?
                                <div className="box new_box">
                                    <input
                                        type="text"
                                        id="Folder_Name"
                                        onChange={this.handle_Change}
                                        value={this.state.Folder_Name}
                                        placeholder="새폴더"
                                        maxLength="10"
                                    />
                                    <button className="new_f" onClick={this.handleSave_Click}>확인</button>
                                </div>
                                :
                                ""
                            }
                            {Edit_Code === 'E' ? Editrender : Moverender}
                        </div>
                    </div>
                </div>
                <Alert
                    id="FolderEditAlert"
                    title={this.state.Title}
                    content={this.state.Content}
                    AlertClick={() => {
                        setTimeout(() => {
                            Big3Common.ModalClose(bootstrap, "FolderEdit");
                        }, 500);
                        if (this.props.CallBack !== undefined) {
                            this.props.CallBack();
                        }
                    }}
                />
            </div>
        );       
    }
}
